import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { BarChartData, PieChartData } from 'api/types/graph'

class Graph {
  //get dashboard charts data
  async getCharts({
    startDate,
    endDate,
    brokerNo,
  }: {
    startDate: string
    endDate: string
    brokerNo: number
  }): Promise<
    Array<PieChartData[] | BarChartData[] | []> | (AxiosError | Error)
  > {
    const url = `${APIRoutes.graph.graph}?startDate=${startDate}&endDate=${endDate}&brokerNo=${brokerNo}`
    return ApiProvider.getRequest(url) as Promise<
      Array<PieChartData[] | BarChartData[] | []> | AxiosError | Error
    >
  }
}

export const graphService = new Graph()
